import {styled} from '@mui/material';
import {DateCalendar} from '@mui/x-date-pickers';

export const StyledDateCalendar = styled(DateCalendar)`
	height: auto;
	width: 100%;
	min-width: unset;
	max-width: 100%;
	box-sizing: border-box;
	gap: 20px;

	${({theme}) => theme.breakpoints.down('sm')} {
		padding-left: 12px;
	}

	& .MuiPickersCalendarHeader-root {
		padding: 0;
		margin: 0;
	}

	& .MuiPickersCalendarHeader-label {
		text-transform: capitalize;
		color: ${({theme}) => theme.palette.text.primary};
		font-weight: 600;
		font-size: 1rem;
	}

	& .MuiMonthCalendar-root {
		justify-content: space-between;

		${({theme}) => theme.breakpoints.down('sm')} {
			gap: 16px;
		}
	}

	& .MuiYearCalendar-root {
		padding: 0px 0px 32px;
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 12px;
		width: 100%;
		max-width: 100%;
		box-sizing: border-box;
		overflow-x: auto;

		${({theme}) => theme.breakpoints.up('sm')} {
			grid-template-columns: repeat(3, 1fr);
			overflow-x: hidden;
		}

		${({theme}) => theme.breakpoints.up('md')} {
			grid-template-columns: repeat(4, 1fr);
		}

		button {
			width: 100% !important;
			height: 48px;
			min-width: unset;
		}
	}

	& .MuiMonthCalendar-button,
	& .MuiYearCalendar-button {
		flex-basis: 19%;
		gap: 22px;
		width: 60px;
		height: 48px;
		margin: 0;
		padding: 12px 16px;
		font-size: 1.125rem;
		text-transform: capitalize;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 8px;
		border: 1px solid ${({theme}) => theme.colors.gray['50Percent']};
	}
`;
